import { Component } from '@angular/core';
import {UserDetailsComponent} from "@spartacus/organization/administration/components";
import {B2BUser} from "@spartacus/core";

@Component({
    selector: 'cx-org-user-details',
    templateUrl: './gonvarri-user-details.component.html',
    styleUrl: './gonvarri-user-details.component.scss',
    standalone: false
})
export class GonvarriUserDetailsComponent extends UserDetailsComponent {

  getOrgUnitName(model: B2BUser): string {
    return model.orgUnit?.name as string;
  }

}
